export default "__VITE_ASSET__43495bcc__"